document.addEventListener('DOMContentLoaded', () => {

  // ===== DESKTOP HOVER =====
  if (window.innerWidth >= 990) {

    // Ny megameny (mm-nav-trigger)
    document.querySelectorAll('.mm-nav-trigger').forEach(trigger => {
      const li = trigger.closest('li');
      if (!li) return;
      const container = li.querySelector('.mega-menu__container');
      if (!container) return;

      let overTrigger = false;
      let overMega = false;

      function open() {
        container.classList.add('is-open');
      }
      function close() {
        container.classList.remove('is-open');
      }
      function maybeClose() {
        if (!overTrigger && !overMega) close();
      }

      trigger.addEventListener('mouseenter', () => { overTrigger = true; open(); });
      trigger.addEventListener('mouseleave', () => { overTrigger = false; setTimeout(maybeClose, 80); });
      container.addEventListener('mouseenter', () => { overMega = true; });
      container.addEventListener('mouseleave', () => { overMega = false; setTimeout(maybeClose, 80); });
    });

    // Gamla megameny (menu__item.relative) – behålls för sidebar/product_list-block
    document.querySelectorAll('.menu__item.relative:not(.mm-nav-trigger)').forEach(item => {
      const mega = item.closest('li')?.querySelector('.mega-menu__container');
      if (!mega) return;

      let overTrigger = false;
      let overMega = false;

      function openMega() {
        mega.style.visibility = 'visible';
        mega.style.transform = 'translateY(0)';
        mega.style.pointerEvents = 'auto';
        mega.style.opacity = '1';
      }
      function closeMega() {
        mega.style.visibility = 'hidden';
        mega.style.transform = 'translateY(-100%)';
        mega.style.pointerEvents = 'none';
        mega.style.opacity = '0';
      }
      function maybeClose() {
        if (!overTrigger && !overMega) closeMega();
      }

      item.addEventListener('mouseenter', () => { overTrigger = true; openMega(); });
      item.addEventListener('mouseleave', () => { overTrigger = false; setTimeout(maybeClose, 80); });
      mega.addEventListener('mouseenter', () => { overMega = true; });
      mega.addEventListener('mouseleave', () => { overMega = false; setTimeout(maybeClose, 80); });
    });
  }

  // ===== MOBIL ACCORDION =====
  document.querySelectorAll('.mega-menu__mobile-trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      const panelId = btn.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (panel) panel.classList.toggle('is-open', !expanded);
    });
  });

});
